Namespace 'Settings.Models.AccountSettings.SocialAccounts'

class Settings.Models.AccountSettings.SocialAccounts.GooglePlayAccount extends Backbone.Model
  urlRoot: 'save'

  defaults:
    uid: '',
    name: '',
    json_file: ''
